import { FC } from 'react'
import { styled } from '../../../../lib/stitches'
import { Box } from '../../../core/Components'
import { SoundIcon } from '../../../core/icons'
import { gray13, gray2 } from '../../../platform/color'

const StyledBlankContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%'
})

const StyledTitle = styled('div', {
  fontSize: '22px',
  lineHeight: '30px',
  fontWeight: 700,
  color: gray13,
  textAlign: 'center'
})

const BlankContainer = StyledBlankContainer
const Title = StyledTitle

const audioTypeByType: Record<'samples' | 'song' | 'stems', 'sample' | 'song' | 'stem'> = {
  samples: 'sample',
  song: 'song',
  stems: 'stem'
}

// TODO: rename type to something more descriptive, also change above record when that is done
const BlankState: FC<{ type?: string; title?: string }> = ({ type, title }) => {
  const makeTitle = () => {
    if (title !== undefined) {
      return title
    }

    return <>Play a {audioTypeByType[type] ?? 'song'} to view the token</>
  }

  return (
    <BlankContainer>
      <Box
        css={{
          borderRadius: '50%',
          background: gray2,
          marginBottom: '12px',
          width: '67px',
          height: '67px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <SoundIcon width="40px" height="100%" />
      </Box>
      <Title css={{ maxWidth: '60%' }}>{makeTitle()}</Title>
    </BlankContainer>
  )
}

export default BlankState
